import { t } from "@/i18n-js/instance";
import { planFeatures } from "@/react/helpers/plansHelpers";
import { FeatureFlags } from "../FeatureFlags";
import { FeatureRow } from "../FeatureRow";
import { PlanFeatureFlag } from "./../PlanFeatureFlag";
import { SectionWrapper } from "./SectionWrapper";
import { StorageRow } from "./StorageRow";

export const Community = () => (
  <SectionWrapper sectionName={t("pricing_plans.section.community")}>
    <FeatureFlags
      featureFlagKeys={[
        planFeatures.max_member_count,
        planFeatures.max_admin_count,
        planFeatures.max_moderator_count,
        planFeatures.max_space_count,
      ]}
    />
    <PlanFeatureFlag
      title={t("pricing_plans.feature.transaction_fees")}
      feature={planFeatures.payments_fee_percentage}
      suffix="%"
    />
    <StorageRow />
    {/* [TODO][ApiBilling][AfterRelease] Utilize the new feature flag for Admin Api Requests  */}
    <FeatureRow
      title={t("pricing_plans.feature.admin_api_requests")}
      business={t("pricing_plans.feature.admin_api_requests_business")}
      enterprise={t("pricing_plans.feature.admin_api_requests_enterprise")}
    />
  </SectionWrapper>
);
